import React from "react";
import {Description, Footer, Image, Layout, Link, LinkGroup} from "./styles";
import {LinkType} from "../../typing";


export interface AdvertProps {
    image: {
        width: number;
        height: number;
        src: string;
    };
    description: string;
    links?: LinkType[];
}
function Advert(props: AdvertProps) {
    const {
        image,
        description,
        links = []
    } = props;
    const {

    } = image;
    return <Layout style={{
        marginLeft: -image.width - 30,
        width: image.width + 8 * 2,
        // width: image.width,
        // height: image.height,
        padding: 8,
    }}>
        <Image alt={"test"} style={{
            width: image.width,
            height: image.height,
        }} src={image.src} />
        <Footer style={{
            width: image.width,
        }}>
            <Description>
                {description}
            </Description>
        </Footer>
        <LinkGroup>
            {links?.map((link) => {
                return <Link target={"_blank"} light={link.light} href={link.href}>
                    {link.title}
                </Link>
            })}
        </LinkGroup>

    </Layout>
}

export default Advert